<template>
<div class="home">

  <div class="main">
    <div class="plk-app" v-show="isApp">
      <!-- <div class="plk-app-logo">e普惠</div> -->
      <div class="plk-app-logo">
        <img src="../assets/img/144.png" alt="">
      </div>
      <div class="plk-app-title">
        <span>好兽药APP</span>
        <strong>电子商城</strong>
      </div>
      <div class="plk-app-right">
        <div class="plk-app-open">
          <div class="app-open">打开APP</div>
          <wx-open-launch-app class="launch-btn" :id="id" :appid="appid" :extinfo="wechatOpenAppData">
            <script type="text/wxtag-template">
              <style>.btn {height: 45px;}</style>
              <div class="btn">打开APP</div>
            </script>
          </wx-open-launch-app>
        </div>
        <!-- <div class="plk-app-open" @click="downloadapp">下载APP</div> -->
        <div class="plk-app-close" @click="closeApp">
          <img src="../assets/img/Delete@3x.png" alt="">
        </div>
      </div>
    </div>
    <div class="plk-app-height" v-show="isApp"></div>
    <div class="plk-img-swiper">
      <cube-slide :initial-index="1" :data="bannerList" ref="slide">
        <cube-slide-item v-for="(item, index) in bannerList" :key="index" @click.native="clickHandler(item, index)">
          <img :src="item.url">
        </cube-slide-item>
      </cube-slide>
    </div>
    <div class="plk-ordinary">
      <div class="ordinary-left">
        <strong>¥{{preferentialPrice}}</strong>
        <span>¥{{retailPrice}}</span>
      </div>
      <div class="ordinary-right">成交量:{{salesTotal}}</div>
    </div>

    <div class="plk-title">
      <div class="plk-goodsName">{{goodsName}}</div>
    </div>

    <div class="plk-back">
      <div class="expert-box">
        <div class="expert-img">
          <img :src="img_uri">
        </div>
        <div class="expert-content">
          <div class="expert-name">
            <div class="name">{{user_name}}</div>
            <div class="line">
              <!-- <span class="inline" v-if="video_if==1">在线</span>
              <span class="outline" v-else>在线</span> -->
            </div>
          </div>
          <div class="expert-label">
            <div class="expert-vocation">{{et_name}}</div>
            <div class="expert-year">从业{{dateNum}}年</div>
          </div>
          <div class="expert-text">
            <div class="title">在线坐诊专家</div>
            <div class="text">{{skills}}</div>
          </div>
          <div class="expert-type">
            <div class="type-title">擅长种类: <span v-for="(item,i) in classid" :key="i">{{item}},</span></div>
          </div>
          <div class="expert-ul">
            <div class="expert-li" v-for="(item,i) in treatment_skill" :key="i">{{item}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="plk-back-bottom">
      <div class="plk-goodslist">
        <div class="goodslist-title">组方详情及用法用量</div>
        <div class="goodslist">
          <div class="goodslist-box" v-for="(item,i) in goodsList" :key="i">
            <div class="goodslist-img">
              <img :src="item.image">
            </div>
            <div class="goodslist-content">
              <div class="goodslist-title">{{item.goodsName}}</div>
              <div class="goodslist-pices">
                <span class="pices">¥{{item.price | priceFloat}}</span>
                <span class="num">x{{item.num}}</span>
              </div>
              <div class="goodslist-text">用法用量:{{item.dosage}}</div>
              <div class="goodslist-company">
                <img src="../assets/img/shop@2x.png">
                <span>{{item.storeName}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="plk-back-top" v-if="itemType == '0' || itemType == '4'">
      <div class="plk-securities">
        <div class="plk-securities-left">领券</div>
        <div class="plk-securities-right">
          <div class="securities" v-for="(item, index) in psCouponBos" :key="index">满{{item.sccAmount}}减{{item.sccPreferentialValue}}</div>
        </div>
      </div>
    </div> -->

    <div class="plk-detail">
      <div class="detail-title">商品详情</div>
      <div class="detail-img">
        <div v-for="(item, index) in detailList" :key="index">
          <img :src="item.url" alt="">
        </div>
      </div>
    </div>

    <div class="plk-height"></div>
    <div class="plk-buton">
      <div class="plk-float-buton" @click="downloadapp">下载APP</div>
    </div>
  </div>
</div>
</template>

<script>
import { iswx, wxshare, getDateYear, classType } from '@/utils/utils.js'
import { compreDetail, getExpertDetail } from '@/api/resetApi.js'

export default {
  name: 'prescriptiondetail',
  data() {
    return {
      cpId: '',
      preferentialPrice: '',
      retailPrice: '',
      salesTotal: '',
      goodsName: '',
      expertUserId: '',
      bannerList: [],
      detailList: [],

      cpThumb: '',
      img_uri: '',
      user_name: '',
      et_name: '',
      dateNum: '',
      skills: '',
      treatment_skill: [],
      video_if: '',
      classid: [],
      goodsList: [],

      isApp: true,
      desc: '我在好兽药上发现了一个经典组方，快来看看吧',

      pageNum: 1,
      pageSize: 3,
      organId: '',
      psCouponBos: [],

      id: 'wxopenLanchAppId',
      appid: 'wxbaafb4b97fb87904',
      wechatOpenAppData: '',
    }
  },
  created(){
    this.cpId = this.$route.query.cpId
    let json = {
      "type": "goods",
      "itemType": "5",
      "activityId": "",
      "itId": this.cpId
    }
    this.wechatOpenAppData = JSON.stringify(json)
    this.prescriptionDetail()
    if (iswx() === true) {
      let wechat = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
      console.log('wechat',wechat)
      let judgewechat = wechat[1].split('.')
      if(judgewechat[0]>=7){
        if(judgewechat[1]>=0){
          if(judgewechat[2]>=12){
            this.openPopup = true
            console.log("当前符合 h5 打开指定app")                    
          }
        }
      }
    }
  },
  mounted() {
    if (this.openPopup == true) {
      var btn = document.getElementById(this.id)
      btn.addEventListener('launch', e => {
        console.log('success');
      });
      btn.addEventListener('error',  e => {
        this.text = e.detail.errMsg
        if (e.detail.errMsg == 'launch:fail') {
          window.location = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.sslab.customer'
        } else {
          this.$createToast({
            txt: e.detail,
            type: 'error'
          }).show()
        }
      });
    }
  },
  methods: {
    // 组方详情
    async prescriptionDetail() {
      let data = {
        cpId: this.cpId,
      }
      const res = await compreDetail(data)
      console.log('res00000=',res)
      try {
        if (res.data.code === 200) {
          this.bannerList = res.data.data.bannerImages
          this.preferentialPrice = res.data.data.cpPrice
          this.retailPrice = res.data.data.price
          this.salesTotal = res.data.data.salesCount
          this.goodsName = res.data.data.cpDesc
          this.goodsList = res.data.data.goods
          this.detailList = res.data.data.detailImages
          this.expertUserId = res.data.data.expertUserId
          this.cpThumb = res.data.data.cpThumb
          this.expertinfo()
          wxshare(this.cpThumb,this.goodsName,this.desc)
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    // 专家详情
    async expertinfo() {
      const res = await getExpertDetail({expertCustomerCode:this.expertUserId})
      console.log(res)
      try {
        if (res.data.code === 200) {
          this.img_uri = res.data.data.expertDetail.headUrl
          this.user_name = res.data.data.expertDetail.userName
          this.et_name = res.data.data.expertDetail.expertFieldDesc
          this.dateNum = res.data.data.expertDetail.yearNum
          this.skills = res.data.data.expertDetail.academicAchievement ? res.data.data.expertDetail.academicAchievement : '执业医师在线接诊/免费视频诊疗，专家经验丰富！'
          this.classid = res.data.data.expertDetail.adeptClass
          this.treatment_skill = res.data.data.expertDetail.adeptLabel
          // this.video_if = res.data.obj.info[0].video_if
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    
    // 下载APP跳转链接
    downloadapp() {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.sslab.customer'
    },
    // 关闭头部下载APP链接
    closeApp() {
      this.isApp = false;
    },
    
    // 优惠券
    async shopenable(type) {
      let data = {
        type: type,
        itId: this.itId,
        organId: this.organId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      const res = await shopEnable(data)
      console.log(res)
      try {
        if (res.data.code === 200) {
          this.psCouponBos = res.data.data.psCouponBos
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    
    changePage(current) {
      console.log('当前轮播图序号为:' + current)
    },
    
    clickHandler(item, index) {
      console.log(item, index)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
}
.main {
  max-width: 768px;
  margin: 0 auto;
  .plk-app {
    display: flex;
    width: 3.75rem;
    height: 0.45rem;
    background: #ea4747;
    position: fixed;
    z-index: 9999;
    .plk-app-logo {
      flex: 0 0 0.4rem;
      margin-left: 0.1rem;
      align-self: center;
      height: 0.4rem;
      border-radius: 0.08rem;
      background: #fff;
      text-align: center;
      font-size: 0.14rem;
      font-weight: 400;
      color: rgba(234,71,71,1);
      line-height: 0.35rem;
      img {
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 0.05rem
      }
    }
    .plk-app-title {
      flex: 1;
      align-self: center;
      text-align: left;
      margin-left: 0.1rem;
      font-size: 0.14rem;
      font-weight: 400;
      color: rgba(255,255,255,1);
      line-height: 0.18rem;
      span {
        display: block;
      }
      strong {
        display: block;
      }
    }
    .plk-app-right {
      flex: 0 0 1.3rem;
      align-self: center;
      display: flex;
      .plk-app-open {
        position: relative;
        flex: 0 0 1rem;
        height: 0.3rem;
        line-height: 0.3rem;
        background: rgba(255,255,255,1);
        border-radius: 0.14rem;
        .app-open {
          text-align: center;
          font-size:  0.14rem;
          font-weight: 400;
          color: rgba(234,71,71,1);
        }
        .launch-btn {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          opacity: 0;
        }
      }
      .plk-app-close {
        flex: 0 0 0.12rem;
        height: 0.3rem;
        line-height: 0.3rem;
        margin-left: 0.05rem;
        align-self: center;
        img {
          vertical-align: top;
          margin-top: 0.08rem;
          width: 0.14rem;
          height: 0.14rem;
        }
      }
    }
  }
  .plk-app-height {
    height: 0.46rem;
  }
  .plk-img-swiper {
    width: 100%;
    height: 3rem;
    overflow: hidden;
    .cube-slide-item {
      text-align: center;
      img {
        max-width: 100%;
        height: 3rem;
        object-fit: cover;
      }
    }
  }

  .plk-ordinary {
    display: flex;
    height: 0.4rem;
    padding: 0 0.1rem;
    .ordinary-left {
      flex: 1;
      align-self: center;
      text-align: left;
      font-size: 0;
      strong {
        font-size: 0.18rem;
        color: #EA4747;
      }
      span {
        margin-left: 0.1rem;
        text-decoration: line-through;
        font-size: 0.1rem;
        color: #9B9B9B;
      }
    }
    .ordinary-right {
      flex: 0 0 1.2rem;
      align-self: center;
      text-align: right;
      font-size: 0.12rem;
      color: #9B9B9B;
    }
  }

  .plk-title {
    padding: 0 0.1rem;
    text-align: left;
    font-size: 0;
    .plk-goodsName {
      padding: 0.1rem 0;
      line-height: 0.2rem;
      font-size: 0.12rem;
      color: #000;
    }
  }

  .expert-box {
    display: flex;
    padding: 0.1rem;
    background: #fff;
    .expert-img {
      flex: 0 0 0.6rem;
      font-size: 0;
      img {
        width: 0.6rem;
        height: 0.6rem;
        border-radius: 50%;
      }
    }
    .expert-content {
      margin-left: 0.1rem;
      .expert-name {
        display: flex;
        .name {
          flex: 1;
          text-align: left;
          font-size: 0.16rem;
          font-weight: bold;
          color: #333;
        }
        .line {
          flex: 0 0 0.5rem;
          font-size: 0;
          .inline {
            display: inline-block;
            width: 0.5rem;
            height: 0.2rem;
            text-align: center;
            line-height: 0.2rem;
            font-size: 0.12rem;
            color: #fff;
            background: #21BE6C;
            border-radius: 0.2rem;
          }
          .outline {
            display: inline-block;
            width: 0.5rem;
            height: 0.2rem;
            text-align: center;
            line-height: 0.2rem;
            font-size: 0.12rem;
            color: #fff;
            background: #bebebe;
            border-radius: 0.2rem;
          }
        }
      }
      .expert-label {
        padding: 0.1rem 0;
        font-size: 0;
        text-align: left;
        .expert-vocation {
          display: inline-block;
          padding: 0.04rem 0.1rem;
          font-size: 0.12rem;
          color: #127BE4;
          border: 1px solid #127BE4;
          border-radius: 0.2rem;
          margin-right: 0.1rem;
        }
        .expert-year {
          display: inline-block;
          padding: 0.04rem 0.1rem;
          font-size: 0.12rem;
          color: #127BE4;
          border: 1px solid #127BE4;
          border-radius: 0.2rem;
        }
      }
      .expert-text {
        text-align: left;
        .title {
          padding-top: 0.05rem;
          font-size: 0.14rem;
          font-weight: bold;
          color: #181818;
        }
        .text {
          padding: 0.1rem 0;
          font-size: 0.12rem;
          color: #999;
        }
      }
      .expert-type {
        text-align: left;
        .type-title {
          font-size: 0.12rem;
          font-weight: bold;
          color: #181818;
        }
      }
      .expert-ul {
        padding-top: 0.1rem;
        text-align: left;
        font-size: 0;
        .expert-li {
          display: inline-block;
          padding: 0.05rem 0.1rem;
          margin: 0 0.02rem 0.05rem 0;
          font-size: 0.12rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: center;
          color: #127be4;
          background: rgba(18,123,228,0.1);
          border-radius: 0.1rem;
        }
      }
    }
  }

  .plk-goodslist {
    padding: 0.1rem;
    background: #fff;
    .goodslist-title {
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: break-word;
      word-break:break-all;
      white-space: normal !important;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      height: 0.3rem;
      line-height: 0.3rem;
      text-align: left;
      font-size: 0.14rem;
      font-weight: bold;
      color: #181818;
    }
    .goodslist {
      text-align: left;
      .goodslist-box {
        display: flex;
        padding: 0.1rem 0;
        border-bottom: 0.01rem solid #ddd;
        &:last-child {
          border-bottom: 0;
        }
        .goodslist-img {
          flex: 0 0 1.1rem;
          height: 1.1rem;
          border: 0.01rem solid #F1F1F1;
          img {
            width: 1.1rem;
            height: 1.1rem;
          }
        }
        .goodslist-content {
          flex: 1;
          position: relative;
          margin-left: 0.1rem;
          .goodslist-title {
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            word-wrap: break-word;
            word-break:break-all;
            white-space: normal !important;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            height: 0.29rem;
            line-height: 0.15rem;
            text-align: left;
            font-size: 0.14rem;
            color: #000;
          }
          .goodslist-pices {
            display: flex;
            padding: 0.08rem 0 0.08rem;
            text-align: left;
            .pices {
              flex: 1;
              font-size: 0.14rem;
              color: #EA4747;
            }
            .num {
              flex: 1;
              text-align: right;
              font-size: 0.14rem;
              color: #9b9b9b;
            }
          }
          .goodslist-text {
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            word-wrap: break-word;
            white-space: normal !important;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            height: 0.3rem;
            line-height: 0.16rem;
            text-align: left;
            font-size: 0.12rem;
            color: #666;
          }
          .goodslist-company {
            width: 100%;
            position: absolute;
            bottom: 0;
            font-size: 0;
            img {
              width: 0.18rem;
              height: 0.18rem;
              vertical-align: middle;
            }
            span {
              margin-left: 0.05rem;
              font-size: 0.12rem;
              color: #181818;
              vertical-align: middle;
            }
          }
        }
      }
    }
  }

  .plk-back {
    padding: 0.1rem 0;
    background: #F7F7F7;
  }
  .plk-back-bottom {
    padding-bottom: 0.1rem;
    background: #F7F7F7;
  }
  .plk-back-top {
    padding-top: 0.1rem;
    background: #F7F7F7;
  }

  .plk-detail {
    font-size: 0;
    text-align: center;
    .detail-title {
      display: inline-block;
      padding: 0.1rem 0 0.05rem;
      font-size: 0.14rem;
      color: #181818;
      border-bottom: 2px solid rgba(223,38,38,1);
    }
    .detail-img {
      padding-top: 0.1rem;
      img {
        width: 100%;
      }
    }
  }
  .plk-height {
    height: 0.45rem;
  }
  .plk-buton {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  .plk-float-buton {
    width: 3.75rem;
    height: 0.45rem;
    margin: 0 auto;
    background: rgba(234,71,71,1);
    text-align: center;
    font-size: 0.14rem;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: rgba(255,255,255,1);
    line-height: 0.45rem;
  }
}
</style>